export const OVERVIEW_ROUTE = {
    title: 'Overview',
    name: 'survey-overview',
};
export const PERFORMANCE_ROUTE = {
    title: 'Performance',
    name: 'survey-performance',
};
export const CAMPAIGN_ROUTE = {
    title: 'Campaign',
    name: 'survey-campaigns',
};
export const BROADCAST_ROUTE = {
    title: 'Broadcast',
    name: 'survey-broadcast',
};
export const CUSTOMER_SEGMENT_ROUTE = {
    title: 'Customer Segment',
    name: 'survey-customer-segment',
};
export const ACTIVITY_ROUTE = {
    title: 'Activity',
    name: 'survey-activities',
};
export const WINNERS_ROUTE = {
    title: 'Winners',
    name: 'survey-winners',
};
export const RAFFLE_DRAW_ROUTE = {
    title: 'Raffle',
    name: 'raffle-draw',
};
export const REFERRALS_ROUTE = {
    title: 'Referrals',
    name: 'survey-referrals',
};
